<div fxLayout="row" fxLayoutGap="10.5%">
    <div
        fxLayout="column"
        fxFlex="0 1 calc(25% - 0.5%)"
        fxFlex.lt-md="0 1 calc(50% - 0.5%)"
        fxFlex.lt-sm="100%"
        fxLayoutAlign="start start"
    >
        <h3><strong>Numero:</strong> {{ oocc.numero }}</h3>
    </div>
    <div
        fxLayout="column"
        fxFlex="0 1 calc(25% - 0.5%)"
        fxFlex.lt-md="0 1 calc(50% - 0.5%)"
        fxFlex.lt-sm="100%"
        fxLayoutAlign="start start"
    >
        <h3><strong> Cliente:</strong> {{ oocc.cliente.nombre }}</h3>
    </div>
</div>

<div fxLayout="row" fxLayoutGap="10.5%">
    <div
        fxLayout="column"
        fxFlex="0 1 calc(25% - 0.5%)"
        fxFlex.lt-md="0 1 calc(50% - 0.5%)"
        fxFlex.lt-sm="100%"
        fxLayoutAlign="start start"
    >
        <h3>
            <strong>Informe: </strong>

            <button
                *ngIf="!oocc.tieneInforme && esSupervisor"
                mat-icon-button
                type="button"
                color="accent"
                (click)="abrirDialogoCargarInforme(oocc.id)"
            >
                <mat-icon>cloud_upload</mat-icon>
            </button>

            <button
                *ngIf="oocc.tieneInforme"
                mat-icon-button
                type="button"
                color="accent"
                (click)="bajarInforme(oocc.id)"
            >
                <mat-icon>cloud_download</mat-icon> Descargar
            </button>

            <!-- input
            type="file"
            #fileInput
            (change)="uploadFile($event)"
            hidden="true"
          / -->
        </h3>
    </div>

    <div
        fxLayout="column"
        fxFlex="0 1 calc(25% - 0.5%)"
        fxFlex.lt-md="0 1 calc(50% - 0.5%)"
        fxFlex.lt-sm="100%"
        fxLayoutAlign="start start"
    >
        <h3>
            <strong>ROC-HES:</strong>
            {{ recepcion ? recepcion.numeroGes : " - " }}
            <!-- button
                mat-icon-button
                type="button"
                color="accent"
                (click)="guardarRocGes(recepcion ? recepcion.numeroGes : null)"
            >
                <mat-icon>edit</mat-icon>
            </button -->
            <button
                *ngIf="recepcion?.filename"
                mat-icon-button
                type="button"
                color="accent"
                (click)="bajarDocumento(oocc.id)"
            >
                <mat-icon>cloud_download</mat-icon> Descargar
            </button>
            <!-- mat-icon-button
    type="button"
    color="accent"
    (click)="guardarRocGes(recepcion ? recepcion.numeroGes : null)"
    >
    <mat-icon>edit</mat-icon>
    </button -->
        </h3>
    </div>
</div>

<div fxLayout="row">
    <div
        fxLayout="column"
        fxFlex="0 1 calc(25% - 0.5%)"
        fxFlex.lt-md="0 1 calc(50% - 0.5%)"
        fxFlex.lt-sm="100%"
        fxLayoutAlign="start start"
    >
        <button
            *ngIf="esRepresentante || esSupervisor"
            mat-icon-button
            type="button"
            color="accent"
            (click)="guardarRocGes(recepcion ? recepcion.numeroGes : null)"
        >
            {{ recepcion ? "ACTUALIZAR" : "AGREGAR ROC-HES" }}
        </button>
    </div>
    <div
        fxLayout="column"
        fxFlex="0 1 calc(25% - 0.5%)"
        fxFlex.lt-md="0 1 calc(50% - 0.5%)"
        fxFlex.lt-sm="100%"
        fxLayoutAlign="start start"
    >
        <button
            *ngIf="!oocc.factura && esSupervisor && recepcion == null"
            mat-button
            color="warn"
            (click)="anular(oocc.id)"
        >
            ANULAR
        </button>
    </div>
</div>
